<div class="date-picker-container" [class.compact]="compact">
  @if (label) {
  <label class="date-picker-label">
    <span> {{ label }}</span>
    @if (required) {
    <span class="required-asterisk">*</span>
    }
  </label>
  }

  <mat-form-field
    [appearance]="appearance"
    [style.width]="width"
    [class]="cssClass"
    [class.input-invalid]="hasError"
    [class.compact]="compact">
    <input
      matInput
      [matDatepicker]="picker"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="value"
      [min]="minDate"
      (dateChange)="onDateSelected($event.value)"
      (click)="openDatePicker(picker)"
      readonly
      (blur)="markAsTouched()" />

    <span
      matSuffix
      (click)="openDatePicker(picker)"
      class="calendar-icon-wrapper">
      <img
        [src]="calendarIcon"
        alt="calendar-icon"
        class="calendar-icon"
        [class.disabled]="disabled" />
    </span>

    <mat-datepicker
      #picker
      [startView]="startView"
      [panelClass]="panelClass"
      (yearSelected)="onYearSelected($event, picker)"
      (monthSelected)="onMonthSelected($event, picker)">
    </mat-datepicker>
  </mat-form-field>

  @if (hasError) {
  <mat-error>
    <div class="error-msg">{{ errorMessage }}</div>
  </mat-error>
  }
</div>
